// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiBox-root{
    /*height: 90% !important;*/
    /*width: auto !important;*/
}
.link{
    text-decoration: underline;
    color: rgb(0, 106, 198);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/adminCore/plan/style.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;AACnB","sourcesContent":[".MuiBox-root{\r\n    /*height: 90% !important;*/\r\n    /*width: auto !important;*/\r\n}\r\n.link{\r\n    text-decoration: underline;\r\n    color: rgb(0, 106, 198);\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
